<template>
    <div>
        <PageContainer
            v-if="pageData"
            :key="$route.meta.id"
        >
            <builder-loop :builder="pageData.builder"></builder-loop>
        </PageContainer>
    </div>
</template>

<script>
import BuilderLoop from 'templates/builder/BuilderLoop';
import PageContainer from 'templates/containers/PageContainer';
import types from 'store/types';

export default {
    name: 'page',
    components: {
        PageContainer,
        BuilderLoop,
    },
    computed: {
        pageData() {
            const pageId = this.$route.meta.id;
            if (typeof this.$store.state.pages.pages[pageId] === 'undefined') {
                return null;
            }
            return this.$store.state.pages.pages[pageId];
        },
    },
    created() {
        const pageId = this.$route.meta.id;
        if (typeof this.$store.state.pages.pages[pageId] === 'undefined') {
            this.$store.dispatch(types.LOAD_PAGE, this.$route.meta.id);
        }
    },
};
</script>

<style lang="scss">

    .l-wrapper {
        --color-main: #{$color-blue-aqua};
        --color-light: #{$color-blue-aqua-light};
    }

</style>
